<template>
  <TableBreadCrumbs :title="pageTitle" />
  <div class="border-0 d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <!-- <i v-if="icon" :class="`${icon} me-2`"></i> -->
      {{ title }}
    </h5>

    <div v-if="showAction" class="d-flex gap-2">
      <button
        v-if="modal"
        class="btn btn-primary btn-sm"
        type="button"
        data-bs-toggle="modal"
        data-original-title="test"
        :data-bs-target="'#' + modal"
        :disabled="disabled"
      >
      <i class="fas fa-plus me-1"></i>
        {{ actionLabel }}
      </button>
      <button v-if="!modal" class="btn btn-primary btn-sm" @click="emitAction" :disabled="disabled">
        <i class="fas fa-plus me-1"></i>
        {{ actionLabel }}
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from "vue";
import TableBreadCrumbs from "./TableBreadCrumbs.vue";

const props = withDefaults(
  defineProps<{
    title: string;
    icon?: string;
    showAction?: boolean;
    modal?: string;
    actionLabel?: string;
    pageTitle?: string;
    disabled?: boolean;
  }>(),
  {
    modal: "",
  }
);

const emit = defineEmits<{
  (e: "action"): void;
}>();

const emitAction = () => {
  emit("action");
};
</script>

<style scoped>
h5 {
  font-size: 20px;
}
</style>
